export default __webpack_public_path__ + "static/media/warning.0f02dc8c.svg";